import 'slick-carousel'

$(() => {
	const $cereal = $('.yco-cereal-slider');

	if (!$cereal.length) {
		return;
	}

	const $options_cereal = {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		infinite: true,
		mobileFirst: true,
		autoplay: false,
		autoplaySpeed: 2000,
		responsive: [
			{
				breakpoint: 1220,
				settings: {
					slidesToShow: 8,
					slidesToScroll: 8,
					dots: false

				}
			},
			{
				breakpoint: 620,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4
				}
			},
			{
				breakpoint: 420,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}
		]
	};

	$cereal.slick($options_cereal);
});



// WEBPACK FOOTER //
// ./assets/scripts/cereal_slider.js